import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ButtonGroup,
  Text,
  Flex,
  Link,
} from '@chakra-ui/react';
import Button from 'common/components/button';
import { useState } from 'react';

const SchoolInfoHelperModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size='xl'>
      <ModalOverlay />
      <ModalContent className='rounded-lg'>
        <ModalHeader className='text-xl font-medium border-b border-gray-200'>
          Why does ReLease ask if you are a student?
        </ModalHeader>
        <ModalBody className='pt-4 pb-6'>
          <Flex className='flex-col gap-4 text-gray-500'>
            <Text className='text-base'>
              These details help us understand your needs for a flexible leasing option, allow us to provide you with coverage options that apply to you, and allow you to make an informed decision before purchasing coverage.
            </Text>
            <Text className='text-base'>
              ReLease will review your plan before activating coverage to ensure accuracy of information provided. Your plan may be amended or your coverage terminated, without refund, in the event that information provided is found to be false or withheld.
            </Text>
          </Flex>
        </ModalBody>
        <ModalFooter className='border-t border-gray-200'>
          <ButtonGroup>
            <Button title='I Understand' onClick={onClose} wFull={false} />
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const SchoolInfoHelperLink = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Link
        onClick={() => setIsOpen(true)}
        className='underline cursor-pointer'
      >
        {children || 'Why do we need this information?'}
      </Link>
      <SchoolInfoHelperModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export { SchoolInfoHelperModal, SchoolInfoHelperLink }; 